var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.663 2.31a.375.375 0 0 1 .674 0l1.782 3.611c.055.111.16.188.283.206l3.986.58c.308.044.431.422.208.64l-2.884 2.811a.375.375 0 0 0-.108.332l.68 3.97a.375.375 0 0 1-.544.396l-3.565-1.874a.375.375 0 0 0-.35 0L4.26 14.856a.375.375 0 0 1-.545-.396l.681-3.97a.375.375 0 0 0-.108-.332L1.404 7.346a.375.375 0 0 1 .208-.64l3.986-.58a.375.375 0 0 0 .283-.205L7.663 2.31Z",
    stroke: "#1AA758",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineIcon);
export default __webpack_public_path__ + "static/media/star-outline-icon.1ec980c8ebc686dd5e71d33ac3152eab.svg";
export { ForwardRef as ReactComponent };